import React from 'react';
import PropTypes from 'prop-types';
import Header from '../components/Header';
import Project from '../components/Project';
import {withScreenCheck, withStore} from '../hoc';
import _ from 'lodash';

/**
 * ProjectPage component
 */
class ProjectPage extends React.Component {
  static displayName = 'ProjectPage';
  static propTypes = {
    className: PropTypes.string,
    screen: PropTypes.string,
    store: PropTypes.object.isRequired,
    currentPage: PropTypes.object.isRequired,
  };
  static defaultProps = {
    className: 'ProjectPage',
  };

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.project = this.project.bind(this);
  }
  /**
   * Select the project that match the current URL.
   */
  project() {
    // Get the maatched project
    const projectID = this.props.currentPage._id;
    return _.first(
      this.props.store.Projects.filter((p) => {
        return p.id === projectID;
      })
    );
  }

  /**
 * @override
 */
  render() {
    return (
      <div className={`${this.className} ${this.props.className || ''}`}>
        <Header
          toggleTag={() => (window.location = '/')}
          unselectTag={() => (window.location = '/')}
          {...this.props}
        />
        <Project project={this.project()} {...this.props} />
      </div>
    );
  }
}

export default withScreenCheck(withStore(ProjectPage), 900);
